import { render, staticRenderFns } from "./InviteCard.vue?vue&type=template&id=ad121014&scoped=true"
import script from "./InviteCard.vue?vue&type=script&lang=js"
export * from "./InviteCard.vue?vue&type=script&lang=js"
import style0 from "./InviteCard.vue?vue&type=style&index=0&id=ad121014&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad121014",
  null
  
)

export default component.exports